import ApiClient from "Store/client";

export const fetchInstructorsApi = (queryString) =>
  ApiClient<Instructor[]>(`api/instructors${queryString}`);

export const fetchInstructorApi = (instructorId) =>
  ApiClient<Instructor>(`api/instructors/${instructorId}`);

export const fetchInstructorSummaryApi = (instructorId) =>
  ApiClient<InstructorSummary>(`api/instructors/${instructorId}/summary`);

export const createNewInstructorApi = (body) =>
  ApiClient(`api/commands/create-instructor`, { method: "POST", body });

export const updateInstructorApi = (body) =>
  ApiClient(`api/commands/update-instructor`, { method: "PATCH", body });

export const updateInstructorAddressApi = (body) =>
  ApiClient(`api/commands/update-instructor-address`, {
    method: "PATCH",
    body
  });

export const deactivateInstructorApi = (body) =>
  ApiClient(`api/commands/disable-an-instructor`, {
    method: "POST",
    body
  });

export const archiveInstructorApi = (body) =>
  ApiClient(`api/commands/archive-instructor`, {
    method: "PATCH",
    body
  });

export const updateInstructorLocationRoleApi = (body) =>
  ApiClient(`api/commands/update-instructor-location-role`, {
    method: "PATCH",
    body
  });

// export const updateInstructorShowWelcomeVideoApi = (body) =>
//   ApiClient(`api/commands/update-instructor-show-welcome-video`, {
//     method: "PATCH",
//     body
//   });

export const deleteInstructorApi = (instructor_id) =>
  ApiClient(`api/commands/delete-an-instructor`, {
    method: "DELETE",
    body: { instructor_id }
  });

export const fetchInstructorClassroomsApi = (instructorId: string) =>
  ApiClient(`api/classrooms?instructor=${instructorId}`);

export const fetchInstructorStatsApi = (instructorId: string) =>
  ApiClient(`api/instructors/${instructorId}/stats`);

export const addInstructorToLocationApi = (body: AddInstructorLocationRequest) =>
  ApiClient(`api/commands/add-instructor-to-location`, {
    method: "POST",
    body
  });

export const removeInstructorFromLocationApi = (body: RemoveInstructorLocationRequest) =>
  ApiClient(`api/commands/remove-instructor-from-location`, {
    method: "DELETE",
    body
  });

export const grantInstructorFullAccessToOrganizationApi = (body: FullAccessToOrganizationRequest) =>
  ApiClient(`api/commands/grant-instructor-full-access-to-organization`, {
    method: "POST",
    body
  });

export const revokeInstructorFullAccessToOrganizationApi = (
  body: FullAccessToOrganizationRequest
) =>
  ApiClient(`api/commands/revoke-instructor-full-access-to-organization`, {
    method: "DELETE",
    body
  });
